function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF"
}, /*#__PURE__*/React.createElement("rect", {
  width: 54,
  height: 113,
  x: 0.5,
  y: 8.5,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.537 32.18l-.021-9.259c.598-3.97 3.91-6.5 8.209-6.5a2828.314 2828.314 0 013.775.005V.502A2823.652 2823.652 0 0085.725.5C72.863.5 62.432 11.151 62.432 24.296c0 .08.043 2.586.122 7.465-.459 4.01-3.73 6.759-7.924 6.948l-.007.25c-.012.448-.022 1.095-.03 1.909a622.16 622.16 0 00-.028 5.81c-.001 2.177.006 4.268.02 5.808a132.165 132.165 0 00.035 2.143c12.117-.247 22.177-10.096 22.917-22.45zM54.38 38.717l-.216.003c.147 0 .243.016.307.02z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54.457 38.565h-4.176c-2.758-.133-5.1-1.862-5.892-4.44l-.066-.284C42.617 26.113 35.587 20.5 27.613 20.5c-9.437 0-17.113 7.627-17.113 17 0 5.24 2.376 10.105 6.523 13.354 3.042 2.386 6.702 3.646 10.59 3.646h26.886l-.042-15.935z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.5 37.632V37.5c0-3.86-3.14-6.999-7-6.999s-7 3.14-7 7c0 2.158.972 4.161 2.67 5.5a6.917 6.917 0 004.33 1.5c3.788 0 6.929-3.082 7-6.868zM8.5 82.5h7v16h-7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 82.5h7v8h-7zM.5 66.5h54v3H.5z"
}));

function SvgRoomFurnaceLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 122,
    viewBox: "0 0 90 122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomFurnaceLarge);
export default __webpack_public_path__ + "static/media/RoomFurnaceLarge.60fb0934.svg";
export { ForwardRef as ReactComponent };